import { render, staticRenderFns } from "./DoughnutChartCard.vue?vue&type=template&id=90525486&"
import script from "./DoughnutChartCard.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartCard.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartCard.vue?vue&type=style&index=0&id=90525486&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports